const keyvalueQueryKeys = {
  all: ['keyvalues'] as const,
  bySubject: (subject?: string) => [...keyvalueQueryKeys.all, subject] as const,
};
export default keyvalueQueryKeys;
